import _ from 'lodash';
import { CONSTANT_DATA_FIELD } from '../../../../utils/constants';

export const PAYMENT_DETAILS: any[] = [
    {
        formData: [
            {
                title: 'Estate Name',
                field: 'estate',
                type: CONSTANT_DATA_FIELD.SELECT_FIELD,
                class: 'col-sm-4'
            },
            {
                titleCode: 'FROM_DATE',
                title: 'From Date',
                field: 'fromDate',
                type: CONSTANT_DATA_FIELD.DATE_FIELD,
                enableFutureDate: false,
                isRequired: true,
                class: 'col-sm-4'
            },
            {
                titleCode: 'TO_DATE',
                title: 'To Date',
                field: 'toDatePayment',
                type: CONSTANT_DATA_FIELD.DATE_FIELD,
                isRequired: true,
                enableFutureDate: false,
                class: 'col-sm-4'
            },
            {
                titleCode: 'DOWNLOAD_OPTIONS',
                title: 'Download Option',
                field: 'downloadOption',
                type: CONSTANT_DATA_FIELD.SELECT_FIELD,
                isRequired: true,
                class: 'col-sm-4'
            }
        ]
    }
];

export const DROPDOWN_DATA = {
    paymentTypes: [
        { code: 'WATER_CHARGES', name: 'Water Charges', active: true },
        { code: 'HOUSE_TAX', name: 'House Tax', active: true }
    ],
    downloadOption: [
        { code: 'INVOICE', name: 'Invoice', active: true },
        { code: 'RECEIPT', name: 'Receipts', active: true },
        { code: 'BOTH', name: 'Both', active: true }
    ]
};
